import { SHARE_BUTTON_DATA, ShareAccessType } from 'shared/_model/sharing/ShareDialog/constants';
import { Box, styled } from '@mui/material';
import Check from '@mui/icons-material/Check';

const AccessTypeButtonTitle = styled('div', { name: 'AccessTypeButtonTitle' })(
	({ theme }) => ({
		fontWeight: theme.typography.fontWeightBold,
		svg: {
			fontSize: theme.spacing(4),
			marginBottom: theme.spacing(1),
			marginRight: theme.spacing(1),
		}
	})
);

const AccessTypeButtonDescription = styled('div', { name: 'AccessTypeButtonDescription' })({
	fontSize: 'small',
});

const SelectedIcon = styled(Check, { name: 'SelectedIcon' })({
	position: 'absolute',
	top: 0,
	right: 0,
});

type AccessTypeButtonProps = {
	value: ShareAccessType;
	selected: boolean;
};

export default function AccessTypeButtonContent({ value, selected }: AccessTypeButtonProps) {
	const { Icon, title, description } = SHARE_BUTTON_DATA[value];

	return (
		<Box
			sx={{
				width: '100%',
				position: 'relative',
				textTransform: 'none',
				textAlign: 'left',
			}}
		>
			{selected && <SelectedIcon />}
			<AccessTypeButtonTitle>
				<Icon />
				{title}
			</AccessTypeButtonTitle>
			<AccessTypeButtonDescription>{description}</AccessTypeButtonDescription>
		</Box>
	);
}
